import { useSyncExternalStore } from "react";

const VISUAL_MESH_MULTI_SELECTION_EVENT = "visual-mesh-multi-selection-changed";

let selectedMeshIds = new Set();

const emitSelectionChanged = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(VISUAL_MESH_MULTI_SELECTION_EVENT, {
      detail: { selectedMeshIds: [...selectedMeshIds] },
    })
  );
};

const subscribe = (listener) => {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(VISUAL_MESH_MULTI_SELECTION_EVENT, listener);
  return () => window.removeEventListener(VISUAL_MESH_MULTI_SELECTION_EVENT, listener);
};

const getSnapshot = () => selectedMeshIds;

const getServerSnapshot = () => new Set();

export const getSelectedVisualMeshIds = () => selectedMeshIds;

export const setSelectedVisualMeshIds = (meshIds) => {
  selectedMeshIds = new Set(meshIds || []);
  emitSelectionChanged();
};

export const toggleVisualMeshInSelection = (meshUuid) => {
  if (!meshUuid) return;
  const next = new Set(selectedMeshIds);
  if (next.has(meshUuid)) {
    next.delete(meshUuid);
  } else {
    next.add(meshUuid);
  }
  selectedMeshIds = next;
  emitSelectionChanged();
};

export const clearSelectedVisualMeshes = () => {
  if (selectedMeshIds.size === 0) return;
  selectedMeshIds = new Set();
  emitSelectionChanged();
};

export const useSelectedVisualMeshIds = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
